import { formatPhoneNumber, isValidNumber } from './phoneNumber';

export const formatDisplayName = (name: string) => {
  if (isValidNumber(name)) {
    return formatPhoneNumber(name);
  }
  return name;
};
